import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { SharingService } from '../../services/share.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-sponsors',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './sponsors.component.html',
  styleUrl: './sponsors.component.scss'
})
export class SponsorsComponent implements OnInit {
  showContactSec: boolean = false;
  sponsorImages: string[] = [
    'Beazer.png', 'CityOfBirmingham.png', 'DrummondCompnay.png', 'ONI.png', 'ibml.png',
    'Aarons.png', 'HibbettSports.png', 'PilotCompany.png', 'Vestis.png', 'Marta.png',
    'UPS.png', 'Regions.png', 'MoMotion.png', 'UAB.png', 'Ebsco.png', 'Hubbel.png',
    'TheHomeDepot.png', 'Mativ.png', 'Delta.png', 'randstad.png', 'Millerzell.jpeg',
    'Brambles.png', 'Americold.png', 'FHLBank.png', 'GeorgiaPacific.png', 'Pultegroup.png',
    'TKE.png', 'Zaxbys.png', 'Yamaha.png', 'SCA Health.png', 'Rollins.png', 'Novelis.png',
    'Mauser.png', 'McWane.png', 'Mansfield.png', 'Huber.png', 'Lendmark.png', 'JAS.png',
    'CRH.png', 'Southwire.png', 'Hooters.png'
  ];
  states: any[] = [];
  toasterTimeout = 3000;
  chunkedSponsors: string[][] = [];
  userForm!: FormGroup;
  submitAttempt: boolean = false;
  loader: boolean = false;
  constructor(private router: Router, private formBuilder: FormBuilder, private svc: SharingService, private toastrService: ToastrService) {
    if (!this.router.url.includes('home')) {
      this.showContactSec = true;
    }
  }

  ngOnInit(): void {
    this.chunkedSponsors = this.chunkSponsors(this.sponsorImages, [43]);
    this.userForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$")])],//, Validators.pattern(this.emailPattern) 
      company: ['', Validators.required],
      title: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', Validators.required],
      zip: [''],
    })
    this.getCompanyStates()

  }

  chunkSponsors(arr: string[], distribution: number[]): string[][] {
    let start = 0;
    return distribution.map(count => arr.slice(start, (start += count)));
  }

  getCompanyStates() {
    var url = 'ListUsaStatesData';
    this.svc.getData(url).subscribe((res: any) => {
      this.states = res.data;
    })
  }



  saveForm() {
    this.submitAttempt = true;
    console.log(this.userForm.value);


    if (this.userForm.valid) {
      var url = 'SponsorForm';
      const fullName = this.userForm.value.name.trim();
      const nameParts = fullName.split(" ");

      let firstName = "";
      let lastName = "";

      if (nameParts.length === 1) {
        firstName = nameParts[0];
        lastName = "";
      } else {
        lastName = nameParts.pop()!; // get the last part
        firstName = nameParts.join(" "); // join the rest
      }

      let obj: any = {

        "firstname": firstName,
        "lastname": lastName,
        "email": this.userForm.value.email,
        "company": this.userForm.value.company,
        "title": this.userForm.value.title,
        "state": this.userForm.value.state,
        "city": this.userForm.value.city,
        "zip": this.userForm.value.zip,
      }
      obj.form_type = 'sponsor';
      this.loader = true;
      this.svc.postData(url, obj).subscribe((Object: any) => {
        this.loader = false;
        this.userForm.reset({
          state: '' // Set state dropdown to empty (default)
        });
        this.submitAttempt = false;
        this.toastrService.clear();
        this.toastrService.success(Object.message, '', {
          closeButton: true,
          timeOut: this.toasterTimeout
        });
      }, err => {
        this.loader = false;
        this.toastrService.clear();
        this.toastrService.error(err.error.message, '', {
          closeButton: true,
          timeOut: this.toasterTimeout
        });
      })
    }
  }
}
